// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"52be4ce68880229525aa","993":"ea16b1639ca6d84bfa24"}[chunkId] + ".js");